import PropTypes from "prop-types";
import "./RoomCapacity.scss";
import { memo } from "react";
import { useIntl } from "react-intl";
import { AdultStrokeIcon, ChildStrokeIcon, BabyStrokeIcon } from "app/icons/profile";

const RoomCapacity = ({ adultCount = 0, childCount = 0, babyCount = 0 }) => {
	const intl = useIntl();

	const getLabel = (count, singularKey, pluralKey) => {
		if (count > 0) {
			const message = count === 1 ? singularKey : pluralKey;
			return intl.formatMessage({ id: message }, { value: count });
		}
		return "";
	};

	const ariaLabel = [
		getLabel(adultCount, "general.adult.singular", "general.adult.plural"),
		getLabel(childCount, "general.child.singular", "general.child.plural"),
		getLabel(babyCount, "general.infant.singular", "general.infant.plural"),
	]
		.filter(label => label !== "")
		.join(", ");

	return (
		<div className="room-capacity" role="img" aria-label={ariaLabel}>
			{Array.from({ length: adultCount }, (_, index) => (
				<AdultStrokeIcon key={`adult-${index}`} data-testid="icon-adult" />
			))}
			{Array.from({ length: childCount }, (_, index) => (
				<ChildStrokeIcon key={`child-${index}`} data-testid="icon-child" />
			))}
			{Array.from({ length: babyCount }, (_, index) => (
				<BabyStrokeIcon key={`baby-${index}`} data-testid="icon-baby" />
			))}
		</div>
	);
};

RoomCapacity.propTypes = {
	adultCount: PropTypes.number,
	childCount: PropTypes.number,
	babyCount: PropTypes.number,
};

export default memo(RoomCapacity);
